import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import CashComponent from '../components/cashComponent/CashComponent';
import YearlyReportCreditCard from '../components/walletCards/YearlyReportCreditCard';
import YearlyReportChart from '../components/yearlyReportChart/YearlyReportChart';
import { DASHBOARD_LINKS } from '../DashboardLinks';
import { usePeriodicFilterItems } from '../hooks/usePeriodicFilterItems';
import {
  WalletYearlyReportMutationParamsType,
  WalletYearlyReportQueryResponseType,
} from '../queries/walletYearlyReport/walletYearlyReportMutation.type';
import { walletYearlyReportMutationOptions } from '../queries/walletYearlyReport/walletYearlyReportMutationOptions';
import { yearlyReportPayloadNormalizer } from '../utils/yearlyReportPayloadNormalizer';

export default () => {
  const navigate = useNavigate();
  return (
    <MainLayout
      backwardHandler={() =>
        navigate(DASHBOARD_LINKS.wallet, { replace: true })
      }
      title="عملکرد ۱۲ ماه اخیر"
      header="titleHeader"
    >
      <WalletYearlyReportPage />
    </MainLayout>
  );
};

function WalletYearlyReportPage() {
  const { items } = usePeriodicFilterItems();
  const payload = yearlyReportPayloadNormalizer(items);

  const {
    mutate,
    isPending,
    data: reportData,
    isSuccess,
  } = walletYearlyReportMutationOptions(
    payload as WalletYearlyReportMutationParamsType,
  );

  useEffect(() => {
    mutate(undefined);
  }, [mutate]);

  if (isPending) return <LoadingPage />;

  return (
    <Flex flexDirection={'column'} pt={12} gap={12}>
      <Flex flexDirection={'column'} gap={16}>
        <Flex justifyContent={'space-between'}>
          <Typography fontWeight={'bold'} fontSize={18}>
            جمع کل کارکرد
          </Typography>
          <CashComponent
            cashValue={reportData?.year?.total_amount.toString() || '0'}
            rialSize={16}
            textProps={{ fontWeight: 'bold' }}
          />
        </Flex>
        <Flex justifyContent={'space-between'}>
          <Flex alignItems={'center'} gap={8}>
            <Box width={10} height={10} bgColor={'gray-1'} borderRadius={50} />
            <Typography textStyle={'h1'}>تسویه نشده</Typography>
          </Flex>
          <CashComponent
            cashValue={reportData?.year?.unpaid.toString() || '0'}
            rialSize={14}
          />
        </Flex>
        <Flex justifyContent={'space-between'}>
          <Flex alignItems={'center'} gap={8}>
            <Box width={10} height={10} bgColor={'green-2'} borderRadius={50} />
            <Typography textStyle={'h1'}>تسویه شده</Typography>
          </Flex>
          <CashComponent
            cashValue={reportData?.year?.paid.toString() || '0'}
            rialSize={14}
          />
        </Flex>
      </Flex>
      {isSuccess && (
        <YearlyReportChart
          monthList={
            reportData?.months as WalletYearlyReportQueryResponseType['months']
          }
        />
      )}
      <Flex
        flexDirection={'column'}
        gap={16}
        bgColor={'white'}
        borderRadius={24}
        borderEndEndRadius={0}
        borderEndStartRadius={0}
        boxShadow={'cardShadow'}
        p={24}
        alignItems={'center'}
      >
        {isSuccess &&
          Object.keys(reportData?.months)
            ?.reverse()
            ?.map((item, index) => (
              <YearlyReportCreditCard
                key={index}
                monthInfo={reportData?.months?.[item]}
              />
            ))}
      </Flex>
    </Flex>
  );
}
